// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';

import indexvideo from '@/views/video';

/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 平台相关配置
import Platform from '@/views/system/Platform';
// 权限管理
import Permission from '@/views/system/Permission';
// 短信记录
import Message from '@/views/system/Message';
// 通知管理
import Notice from '@/views/system/Notice';

/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

// 其知网
// 专利缴费
import webFeepay from '@/views/web/Feepay';
// 文章管理
import webNews from '@/views/web/News';
// 其说论坛
import webPlatform from '@/views/web/Platform';
// 问题与建议
import webproblem from '@/views/web/problem';
// 用户管理
import webuser from '@/views/web/user';
// 专利监控
import webpatentmonitor from '@/views/web/Patentmonitor';
// 年费提醒
import webpatentremind from '@/views/web/Patentremind';
// 专利申请
import webpatentapply from '@/views/web/Patentapply';
// 近期登陆
import webuserlog from '@/views/web/Userlog';
// 专利市场
import webpatentmarket from '@/views/web/Patentmarket';
// 求购出售
import webforsale from '@/views/web/Forsale';
// 代理人管理
import webagent from '@/views/web/Agent';
// 分类管理
import webcategory from '@/views/web/Category';
// 其知学院
import webcollege from '@/views/web/College';
// 轮播图管理
import webBanner from '@/views/web/Banner';
// API日志
import webApiuse from '@/views/web/Apiuse';

// 出售管理
import webSale from '@/views/web/Sale';
// 专利出售
import webMarket from '@/views/web/Market';
// 求购管理
import webBuy from '@/views/web/Buy';

// Excel模板管理
import webTemExcel from '@/views/web/Temexcel';
// 收藏管理
import webCollection from '@/views/web/Collection';

// 专利卫士 
// 缴费管理
import wechatFeepay from '@/views/wechat/Feepay';
// 专利监控
import wechatPatentmonitor from '@/views/wechat/Patentmonitor';
// 提醒管理
import wechatPatentremind from '@/views/wechat/Patentremind';
// PDF订单
import wechatOrderpdf from '@/views/wechat/Orderpdf';
// 用户管理
import wechatPatentuser from '@/views/wechat/Patentuser';
// API日志
import wechatApiuse from '@/views/wechat/Apiuse';
// 退款管理
import wechatRefund from '@/views/wechat/Refund';
// 服务费发票管理
import wechatServiceFee from '@/views/wechat/serviceFee';
// 发票申请
import wechatTicketApply from '@/views/wechat/ticketApply';
// 规费指引
import wechatGuide from '@/views/wechat/Guide';
// 涉及组织国家
import wechatCountry from '@/views/wechat/Country';
// 预审优审中心
import wechatPreCity from '@/views/wechat/PreCity';
// 专利价值评估报告订单
import wechatReportOrder from '@/views/wechat/ReportOrder';
// 专利申请预评估报告订单
import wechatPreOrder from '@/views/wechat/PreOrder';
// 积分充值订单
import wechatRechargeOrder from '@/views/wechat/rechargeOrder';
// 等级升级订单
import wechatUpgradeOrder from '@/views/wechat/upgradeOrder';


//高企认定
//报告管理
import gqchatBusireport from '@/views/gqchat/Busireport';
//用户管理
import gqchatBusiuser from '@/views/gqchat/Busiuser';
//Api日志
import gqchatApiuse from '@/views/gqchat/Apiuse';

//首页
import indexIndex from '@/views/index/index';
//首页 个人中心
import indexContent from '@/views/index/content';

// 用户管理
import userManage from '@/views/user/user';

// 推广管理
import userInvite from '@/views/user/invite';

// 其知创新
// 新闻管理
import officeNews from '@/views/office/News';
// 政策管理
import officePolicys from '@/views/office/Policys';
// 项目管理
import officeProjects from '@/views/office/Projects';

// 专利管理
// 监控提醒
import patentPatentremind from '@/views/patent/Patentremind';
// 年费查询
import patentQueryfee from '@/views/patent/Queryfee';
// 年费管理
import patentFeemanage from '@/views/patent/Feemanage';
// 申请号管理
import patentApplynumber from '@/views/patent/Applynumber';
// 审中专利管理
import patentTrial from '@/views/patent/Trial';
// 专利爬虫记录(专利卫士)
import patentReptile from '@/views/patent/Reptile';
// 专利爬虫记录(代理机构)
import patentReptileAgency from '@/views/patent/ReptileAgency';
// 专利爬虫记录(新监控)
import patentReptileMonitor from '@/views/patent/ReptileMonitor';
// 专利爬虫记录(专利卫士-近期待缴)
import patentReptileNear from '@/views/patent/ReptileNear';
// 导入专利爬虫记录
import patentImport from '@/views/patent/Import';

// 购物卡管理
import shopCard from '@/views/shop/Shopcard';
// 用户购物卡
import UserShopCard from '@/views/shop/Usershopcard';

// 邮件系统
// 邮箱管理
import MailEmail from '@/views/mail/email';
// 模板管理
import MailTemp from '@/views/mail/template';
// 任务管理
import MailTask from '@/views/mail/task';
// 执行管理
import MailExecute from '@/views/mail/execute';


// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [
    //     {
    //     path: '/',
    //     name: '',
    //     component: login,
    //     hidden: true,
    //     meta: {
    //         requireAuth: false
    //     }
    // }, 
    {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, 
    {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/pay/Order',
            name: '交易订单',
            component: Order,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Module',
            name: '菜单管理',
            component: Module,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Dept',
            name: '公司管理',
            component: Dept,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Variable',
            name: '系统环境变量',
            component: Variable,
            meta: {
                requireAuth: true
            }
        },{
            path: '/system/Platform',
            name: '平台相关配置',
            component: Platform,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        },{
            path: '/system/Message',
            name: '短信记录',
            component: Message,
            meta: {
                requireAuth: true
            }
        },{
            path: '/system/Notice',
            name: '通知管理',
            component: Notice,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/druid/login',
            name: '监控查询',
            component: druidLogin,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/statistics',
            name: '数据可视化',
            component: statistics,
            meta: {
                requireAuth: true
            } 
        },{
            path: '/wechat/Feepay',
            name: '专利缴费',
            component: wechatFeepay,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/Feepay',
            name: '缴费管理',
            component: webFeepay,
            meta: {
                requireAuth: true
            }
        },{
            path: '/wechat/Patentmonitor',
            name: '专利监控',
            component: wechatPatentmonitor,
            meta: {
                requireAuth: true
            }
        },{
            path: '/wechat/Patentremind',
            name: '提醒管理',
            component: wechatPatentremind,
            meta: {
                requireAuth: true
            }
        },{
            path: '/wechat/Orderpdf',
            name: 'PDF订单',
            component: wechatOrderpdf,
            meta: {
                requireAuth: true
            }
        },{
            path: '/wechat/Patentuser',
            name: '用户管理',
            component: wechatPatentuser,
            meta: {
                requireAuth: true
            }
        },{
            path: '/wechat/Apiuse',
            name: 'API日志',
            component: wechatApiuse,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/wechat/Refund',
            name: '退款管理',
            component: wechatRefund,
            meta: {
                requireAuth: true
            }
        },{
            path: '/wechat/serviceFee',
            name: '服务费发票',
            component: wechatServiceFee,
            meta: {
                requireAuth: true
            }
        },{
            path: '/wechat/ticketApply',
            name: '发票申请',
            component: wechatTicketApply,
            meta: {
                requireAuth: true
            }
      },{
            path: '/wechat/Guide',
            name: '规费指引',
            component: wechatGuide,
            meta: {
                requireAuth: true
            }
      },{
        path: '/wechat/Country',
        name: '涉及组织国家',
        component: wechatCountry,
        meta: {
            requireAuth: true
        }
      },{
        path: '/wechat/PreCity',
        name: '预(优)审中心',
        component: wechatPreCity,
        meta: {
            requireAuth: true
        }
      },{
        path: '/wechat/ReportOrder',
        name: '评估报告',
        component: wechatReportOrder,
        meta: {
            requireAuth: true
         }
      },{
        path: '/wechat/PreOrder',
        name: '申请预评估报告',
        component: wechatPreOrder,
        meta: {
            requireAuth: true
         }
      },{
        path: '/wechat/rechargeOrder',
        name: '积分充值订单',
        component: wechatRechargeOrder,
        meta: {
            requireAuth: true
         }
      },{
        path: '/wechat/upgradeOrder',
        name: '等级升级订单',
        component: wechatUpgradeOrder,
        meta: {
            requireAuth: true
         }
      },{
        path: '/gqchat/Busireport',
        name: '报告管理',
        component: gqchatBusireport,
        meta: {
            requireAuth: true
        }
        },{
            path: '/gqchat/Busiuser',
            name: '用户管理',
            component: gqchatBusiuser,
            meta: {
                requireAuth: true
            }
        },{
            path: '/gqchat/Apiuse',
            name: '用户管理',
            component: gqchatApiuse,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/News',
            name: '其观管理',
            component: webNews,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/Platform',
            name: '其说论坛',
            component: webPlatform,
            meta: {
                requireAuth: true
            }
        },{
            path: '/index/index',
            name: '首页',
            component: indexIndex,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/problem',
            name: '问题与建议',
            component: webproblem,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/user',
            name: '用户管理',
            component: webuser,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/Patentmonitor',
            name: '用户管理',
            component: webpatentmonitor,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/Patentremind',
            name: '年费提醒',
            component: webpatentremind,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/Patentapply',
            name: '专利申请',
            component: webpatentapply,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/Userlog',
            name: '专利申请',
            component: webuserlog,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/Patentmarket',
            name: '专利市场',
            component: webpatentmarket,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/Forsale',
            name: '求购出售',
            component: webforsale,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/Agent',
            name: '代理人管理',
            component: webagent,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/Category',
            name: '分类管理',
            component: webcategory,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/college',
            name: '其知学院',
            component: webcollege,
            meta: {
                requireAuth: true
            }
        },{
            path: '/index/video',
            name: '视频上传',
            component: indexvideo,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/index/content',
            name: '个人中心',
            component: indexContent,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/Banner',
            name: '轮播图管理',
            component: webBanner,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/Sale',
            name: '出售管理',
            component: webSale,
            meta: {
                requireAuth: true
            }
        },{
          path: '/web/Market',
          name: '专利出售',
          component: webMarket,
          meta: {
              requireAuth: true
          }
        },{
            path: '/web/Buy',
            name: '求购管理',
            component: webBuy,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/Temexcel',
            name: '模板管理',
            component: webTemExcel,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/web/Apiuse',
            name: 'API日志',
            component: webApiuse,
            meta: {
                requireAuth: true
            }
        },{
            path: '/web/Collection',
            name: '收藏管理',
            component: webCollection,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/user',
            name: '用户管理',
            component: userManage,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/invite',
            name: '推广管理',
            component: userInvite,
            meta: {
                requireAuth: true
            }
        },{
            path: '/office/News',
            name: '新闻管理',
            component: officeNews,
            meta: {
                requireAuth: true
            }
        },{
            path: '/office/Policys',
            name: '政策管理',
            component: officePolicys,
            meta: {
                requireAuth: true
            }
        },{
            path: '/office/Projects',
            name: '项目管理',
            component: officeProjects,
            meta: {
                requireAuth: true
            }
        },{
            path: '/patent/Patentremind',
            name: '监控提醒',
            component: patentPatentremind,
            meta: {
                requireAuth: true
            }
        },{
            path: '/patent/Queryfee',
            name: '年费查询',
            component: patentQueryfee,
            meta: {
                requireAuth: true
            }
        },{
            path: '/patent/Feemanage',
            name: '年费管理',
            component: patentFeemanage,
            meta: {
                requireAuth: true
            }
        },{
            path: '/patent/Applynumber',
            name: '申请号管理',
            component: patentApplynumber,
            meta: {
                requireAuth: true
            }
        },{
            path: '/patent/Trial',
            name: '审中专利管理',
            component: patentTrial,
            meta: {
                requireAuth: true
            }
        },{
            path: '/patent/Reptile',
            name: '专利爬虫记录',
            component: patentReptile,
            meta: {
                requireAuth: true
            }
        },{
            path: '/patent/ReptileAgency',
            name: '专利爬虫记录(代)',
            component: patentReptileAgency,
            meta: {
                requireAuth: true
            }
        },{
            path: '/patent/ReptileMonitor',
            name: '专利爬虫记录(监)',
            component: patentReptileMonitor,
            meta: {
                requireAuth: true
            }
        },{
            path: '/patent/ReptileNear',
            name: '专利爬虫记录(近)',
            component: patentReptileNear,
            meta: {
                requireAuth: true
            }
        },{
            path: '/patent/Import',
            name: '导入专利爬虫记录',
            component: patentImport,
            meta: {
                requireAuth: true
            }
        },{
            path: '/shop/Shopcard',
            name: '购物卡管理',
            component: shopCard,
            meta: {
                requireAuth: true
            }
        },{
            path: '/shop/Usershopcard',
            name: '用户购物卡',
            component: UserShopCard,
            meta: {
                requireAuth: true
            }
        },{
          path: '/mail/email',
          name: '邮箱管理',
          component: MailEmail,
          meta: {
              requireAuth: true
              }
        },{
            path: '/mail/template',
            name: '模板管理',
            component: MailTemp,
            meta: {
                requireAuth: true
            }
        },{
          path: '/mail/task',
          name: '任务管理',
          component: MailTask,
          meta: {
              requireAuth: true
          }
        },{
          path: '/mail/execute',
          name: '执行管理',
          component: MailExecute,
          meta: {
              requireAuth: true
          }
        }]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js